import { create } from 'zustand';

interface CookiePreferences {
  necessary: boolean;
  functional: boolean;
  analytics: boolean;
  timestamp: string;
}

interface CookieState {
  preferences: CookiePreferences | null;
  bannerShown: boolean;
  setPreferences: (prefs: Omit<CookiePreferences, 'timestamp'>) => void;
  acceptAll: () => void;
  acceptNecessary: () => void;
  dismissBanner: () => void;
  showBanner: () => void;
}

const STORAGE_KEY = 'SmartDental_cookie_consent';

function readStoredPreferences(): CookiePreferences | null {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

const stored = readStoredPreferences();

export const useCookieStore = create<CookieState>()((set) => ({
  preferences: stored,
  bannerShown: !stored,

  setPreferences: (prefs) => {
    const full: CookiePreferences = {
      ...prefs,
      necessary: true,
      timestamp: new Date().toISOString(),
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(full));
    set({ preferences: full, bannerShown: false });
  },

  acceptAll: () => {
    const full: CookiePreferences = {
      necessary: true,
      functional: true,
      analytics: true,
      timestamp: new Date().toISOString(),
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(full));
    set({ preferences: full, bannerShown: false });
  },

  acceptNecessary: () => {
    const full: CookiePreferences = {
      necessary: true,
      functional: false,
      analytics: false,
      timestamp: new Date().toISOString(),
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(full));
    set({ preferences: full, bannerShown: false });
  },

  dismissBanner: () => set({ bannerShown: false }),
  showBanner: () => set({ bannerShown: true }),
}));
